export enum ReportsTableColumnDataIndex {
  Report = "report",
  UrlPrefix = "urlPrefix",
  Options = "options",
}
